<template>
  <v-expansion-panels :accordion="true">
    <v-expansion-panel
      class="mb-2"
      v-for="(item, i) in items"
      :key="'expansion-panel-' + i"
    >
      <v-expansion-panel-header>
        <slot :name="`item.${item.value}.title`">
          {{ item.title }}
        </slot>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot :name="`item.${item.value}.content`">
          <div v-html="item.text"></div>
        </slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.v-expansion-panels {
  border-radius: 0;
}

.v-expansion-panel::before {
  display: none;
}

.v-expansion-panels--accordion > .v-expansion-panel {
  border-radius: 6px;
}

.v-expansion-panels--accordion > .v-expansion-panel::after {
  display: none;
}

.v-expansion-panel-header {
  padding: 24px;
  color: var(--v-primary-base);
  font-size: 14px;
  font-weight: 600;
}

.v-expansion-panel-content {
  color: var(--v-primary-base);
  font-size: 14px;
  line-height: 23px;
}
</style>
